import { FC } from "react";
import { Form, InputGroup } from "react-bootstrap";

interface InputFieldProps {
  id?: string;
  label: string;
  name: string;
  formik: any;
  type: string;
  className: string;
  readonly?: boolean;
  disabled?: boolean;
  handleChange?: (e: any) => void;
}

const InputField: FC<InputFieldProps> = ({
  id,
  name,
  label,
  formik,
  type,
  className,
  readonly,
  disabled,
  handleChange,
}) => {
  return (
    <div className={className}>
      <InputGroup>
        <InputGroup.Text>{label}</InputGroup.Text>
        <Form.Control
          id={id}
          type={type}
          name={name}
          disabled={disabled}
          onChange={handleChange ? handleChange : formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[name]}
          readOnly={readonly}
        />
      </InputGroup>
      {formik.touched[name] && formik.errors[name] && (
        <Form.Text className="error-message">{formik.errors[name]}</Form.Text>
      )}
    </div>
  );
};

export default InputField;
